"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  return {
    Item: {
      cursor: 'pointer',
      listStyleType: 'none',
      fontFamily: theme['$font-default'],
      fontSize: 12,
      padding: {
        top: 6,
        bottom: 6,
        left: 11,
        right: 11
      },
      '&:hover': {
        background: theme['$menu-highlight-background-color']
      }
    },
    ActiveItem: {
      background: theme['$menu-active-background-color']
    },
    Disabled: {
      pointerEvents: 'none',
      color: theme['$placeholder-color']
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map